var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasPermissionsTo(['manage-monitoring']))?_c('Dashboard'):_c('h3',[_vm._v("Welcome to Acadia!")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }